import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  'https://oaresnccabggvsfdyecj.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9hcmVzbmNjYWJnZ3ZzZmR5ZWNqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIxNTYyNTMsImV4cCI6MjA1NzczMjI1M30.EVnlCMjO7kL3N0SkCMKF5M_xqCeAZqjagbzQ4_6B8T0'
);